// extracted by mini-css-extract-plugin
var _1 = "SliderGroup-module__container___lF9s8";
var _2 = "SliderGroup-module__label___jCnxh";
var _3 = "SliderGroup-module__slider___BpVuW";
export { _1 as "container", _2 as "label", _3 as "slider" }
